import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { FiChevronDown } from 'react-icons/fi'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab5 = ({
    taxId, setTaxId,
    settaxCategory, taxcategory, taxcatlist,
    taxwithholdlist, setTaxwithholds, taxwithholds,
    price, setPrice, pricelist,
    gst, setGst, setPan, pan,
    GstCategorylist, setGstCategory, gstCategory,customerName
}) => {

    const [isGroup, setIsGroup] = useState(0)


    return (
        <div>
            <div
                className="row mb-3"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Details</p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>

                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="CustomerName"
                                label="Tax ID"
                                style={{ height: "30px" }}
                                readOnly
                                value={taxId}
                                onChange={(e) => setTaxId(e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Tax Category"
                                value={taxcategory}
                                readOnly
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="Tax Withholding Category"
                                value={taxwithholds}
                                readOnly
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="row mb-3 mt-5"
                style={{ border: "1px solid #00000059", borderRadius: "5px" }}
            >
                <div className="col-12">
                    <p className="boxLabel m-0">Tax Details</p>
                </div>

                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>

                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="GSTIN / UIN"
                                label="GSTIN / UIN"
                                style={{ height: "30px" }}
                                readOnly
                                value={gst}
                                onChange={(e) => setGst(e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                id="PAN"
                                label="PAN"
                                style={{ height: "30px" }}
                                value={pan}
                                readOnly
                                onChange={(e) => setPan(e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                label="GST Category"
                                value={gstCategory}
                                readOnly
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
                 <div className="">
                <ActivityCard doctype="Customer" docname={customerName} />
            </div>

        </div>


    )
}

export default Tab5